/**
 * OVERRIDE View.jsx
 */

import View from '../../../../../components/Blocks/Maps/View';

export default View;